import {
    check,
	stages,
    levels,
    singleLevel,
	accounts,
	users,
	currencies,
	countries,
	schoolTypes,
	classRooms,
	players,
    teachers,
    settings,
    badges,
    parts
} 	from '../services/contentServices'

export const CONTENT_ERROR = 'CONTENT_ERROR'
export const FORBIDDEN_ERROR = 'FORBIDDEN_ERROR'

export const CLEAR_STORE = 'CLEAR_STORE'

export const STAGES_REQUEST = 'STAGES_REQUEST'
export const STAGES_SUCCESS = 'STAGES_SUCCESS'

export const LEVELS_REQUEST = 'LEVELS_REQUEST'
export const LEVELS_SUCCESS = 'LEVELS_SUCCESS'

export const SINGLE_LEVEL_REQUEST = 'SINGLE_LEVEL_REQUEST'
export const SINGLE_LEVEL_SUCCESS = 'SINGLE_LEVEL_SUCCESS'

export const ACCOUNTS_REQUEST = 'ACCOUNTS_REQUEST'
export const ACCOUNTS_SUCCESS = 'ACCOUNTS_SUCCESS'

export const USERS_REQUEST = 'USERS_REQUEST'
export const USERS_SUCCESS = 'USERS_SUCCESS'

export const CURRENCIES_REQUEST = 'CURRENCIES_REQUEST'
export const CURRENCIES_SUCCESS = 'CURRENCIES_SUCCESS'

export const COUNTRIES_REQUEST = 'COUNTRIES_REQUEST'
export const COUNTRIES_SUCCESS = 'COUNTRIES_SUCCESS'

export const SCHOOLTYPES_REQUEST = 'SCHOOLTYPES_REQUEST'
export const SCHOOLTYPES_SUCCESS = 'SCHOOLTYPES_SUCCESS'

export const CLASSROOMS_REQUEST = 'CLASSROOMS_REQUEST'
export const CLASSROOMS_SUCCESS = 'CLASSROOMS_SUCCESS'

export const PLAYERS_REQUEST = 'PLAYERS_REQUEST'
export const PLAYERS_SUCCESS = 'PLAYERS_SUCCESS'

export const TEACHERS_REQUEST = 'TEACHERS_REQUEST'
export const TEACHERS_SUCCESS = 'TEACHERS_SUCCESS'

export const SETTINGS_REQUEST = 'SETTINGS_REQUEST'
export const SETTINGS_SUCCESS = 'SETTINGS_SUCCESS'

export const BADGES_REQUEST = 'BADGES_REQUEST'
export const BADGES_SUCCESS = 'BADGES_SUCCESS'

export const PARTS_REQUEST = 'PARTS_REQUEST'
export const PARTS_SUCCESS = 'PARTS_SUCCESS'

export var checkAction = () => dispatch => {    
    return check()
        .catch(err => {
            dispatch({ type: CONTENT_ERROR, err})
        })
}

export const stagesAction = (page, all, levels) => dispatch => {
    dispatch({ type: STAGES_REQUEST})
    return stages(page, all, levels)
        .then(res =>{
            let data = res;
            dispatch({ type: STAGES_SUCCESS, data})
        })
        .catch(err => {
			if (err.message == 'Forbidden') {
				dispatch({ type: FORBIDDEN_ERROR, err})
			} else {
				dispatch({ type: CONTENT_ERROR, err})
			}
        })
}

export const levelsAction = (id) => dispatch => {
    dispatch({ type: LEVELS_REQUEST})
    return levels(id)
        .then(res =>{
            let data = res;
            dispatch({ type: LEVELS_SUCCESS, data})
        })
        .catch(err => {
			if (err.message == 'Forbidden') {
				dispatch({ type: FORBIDDEN_ERROR, err})
			} else {
				dispatch({ type: CONTENT_ERROR, err})
			}
        })
}

export const singleLevelAction = (id) => dispatch => {
    dispatch({ type: SINGLE_LEVEL_REQUEST})
    return singleLevel(id)
        .then(res =>{
            let data = res;
            dispatch({ type: SINGLE_LEVEL_SUCCESS, data})
        })
        .catch(err => {
			if (err.message == 'Forbidden') {
				dispatch({ type: FORBIDDEN_ERROR, err})
			} else {
				dispatch({ type: CONTENT_ERROR, err})
			}
        })
}

export const accountsAction = (page) => dispatch => {
    dispatch({ type: ACCOUNTS_REQUEST})
    return accounts(page)
        .then(res =>{
            let data = res;
            dispatch({ type: ACCOUNTS_SUCCESS, data})
        })
        .catch(err => {
            dispatch({ type: CONTENT_ERROR, err})
        })
}

export const usersAction = (id, page) => dispatch => {
    dispatch({ type: USERS_REQUEST})
    return users(id, page)
        .then(res =>{
            let data = res;
            dispatch({ type: USERS_SUCCESS, data})
        })
        .catch(err => {
            dispatch({ type: CONTENT_ERROR, err})
        })
}

export const currenciesAction = (page) => dispatch => {
    dispatch({ type: CURRENCIES_REQUEST})
    return currencies(page)
        .then(res =>{
            let data = res;
            dispatch({ type: CURRENCIES_SUCCESS, data})
        })
        .catch(err => {
            dispatch({ type: CONTENT_ERROR, err})
        })
}

export const countriesAction = () => dispatch => {
    dispatch({ type: COUNTRIES_REQUEST})
    return countries()
        .then(res =>{
            let data = res;
            dispatch({ type: COUNTRIES_SUCCESS, data})
        })
        .catch(err => {
            dispatch({ type: CONTENT_ERROR, err})
        })
}

export const schoolTypesAction = () => dispatch => {
    dispatch({ type: SCHOOLTYPES_REQUEST})
    return schoolTypes()
        .then(res =>{
            let data = res;
            dispatch({ type: SCHOOLTYPES_SUCCESS, data})
        })
        .catch(err => {
			if (err.message == 'Forbidden') {
				dispatch({ type: FORBIDDEN_ERROR, err})
			} else {
				dispatch({ type: CONTENT_ERROR, err})
			}
        })
}

export const classRoomsAction = (accountId, page) => dispatch => {
    dispatch({ type: CLASSROOMS_REQUEST})
    return classRooms(accountId, page)
        .then(res =>{
            let data = res;
            dispatch({ type: CLASSROOMS_SUCCESS, data})
        })
        .catch(err => {
			if (err.message == 'Forbidden') {
				dispatch({ type: FORBIDDEN_ERROR, err})
			} else {
				dispatch({ type: CONTENT_ERROR, err})
			}
        })
}

export const playersAction = (accountId, id) => dispatch => {
    dispatch({ type: PLAYERS_REQUEST})
    return players(accountId, id)
        .then(res =>{
            let data = res;
            dispatch({ type: PLAYERS_SUCCESS, data})
        })
        .catch(err => {
			if (err.message == 'Forbidden') {
				dispatch({ type: FORBIDDEN_ERROR, err})
			} else {
				dispatch({ type: CONTENT_ERROR, err})
			}
        })
}

export const teachersAction = (accountId, page) => dispatch => {
    dispatch({ type: TEACHERS_REQUEST})
    return teachers(accountId, page)
        .then(res =>{
            let data = res;
            dispatch({ type: TEACHERS_SUCCESS, data})
        })
        .catch(err => {
			if (err.message == 'Forbidden') {
				dispatch({ type: FORBIDDEN_ERROR, err})
			} else {
				dispatch({ type: CONTENT_ERROR, err})
			}
        })
}

export const settingsAction = () => dispatch => {
    dispatch({ type: SETTINGS_REQUEST})
    return settings()
        .then(res =>{
            let data = res;
            dispatch({ type: SETTINGS_SUCCESS, data})
        })
        .catch(err => {
			if (err.message == 'Forbidden') {
				dispatch({ type: FORBIDDEN_ERROR, err})
			} else {
				dispatch({ type: CONTENT_ERROR, err})
			}
        })
}

export const badgesAction = () => dispatch => {
    dispatch({ type: BADGES_REQUEST})
    return badges()
        .then(res =>{
            let data = res;
            dispatch({ type: BADGES_SUCCESS, data})
        })
        .catch(err => {
			if (err.message == 'Forbidden') {
				dispatch({ type: FORBIDDEN_ERROR, err})
			} else {
				dispatch({ type: CONTENT_ERROR, err})
			}
        })
}

export const partsAction = () => dispatch => {
    dispatch({ type: PARTS_REQUEST})
    return parts()
        .then(res =>{
            let data = res;
            dispatch({ type: PARTS_SUCCESS, data})
        })
        .catch(err => {
			if (err.message == 'Forbidden') {
				dispatch({ type: FORBIDDEN_ERROR, err})
			} else {
				dispatch({ type: CONTENT_ERROR, err})
			}
        })
}



// WEBPACK FOOTER //
// ./src/actions/contentActions.js